import type { QualityLevel, SelectedSortByValue } from '@/entities/quality';
import type { DataZoneLowerCaseString, QualityDetailDateRange } from '@/entities/quality/domain/type';

import { DATA_QUALITY_OPTIONS, DATA_ZONE_OPTIONS, DATE_OPTIONS, SORT_BY_OPTIONS } from './options';

export type FilterKey = 'dataZone' | 'dataQuality' | 'dateRange' | 'sortBy';

export type FilterStoreKey =
  | 'selectedDataZoneValue'
  | 'selectedDataQualityValue'
  | 'selectedDateRangeValue'
  | 'selectedSortByValue';

export type FilterConfigItem<T = string> = {
  key: FilterKey;
  buttonText: string;
  width: number;
  options: { label: string; value: T }[];
  storeKey: FilterStoreKey;
};

export const FILTER_CONFIGS: FilterConfigItem<string | number>[] = [
  {
    key: 'dataZone',
    buttonText: '데이터 존',
    width: 180,
    options: DATA_ZONE_OPTIONS,
    storeKey: 'selectedDataZoneValue',
  },
  {
    key: 'dataQuality',
    buttonText: '데이터 품질',
    width: 250,
    options: DATA_QUALITY_OPTIONS,
    storeKey: 'selectedDataQualityValue',
  },
  {
    key: 'dateRange',
    buttonText: '기간',
    width: 180,
    options: DATE_OPTIONS,
    storeKey: 'selectedDateRangeValue',
  },
  {
    key: 'sortBy',
    buttonText: '정렬',
    width: 200,
    options: SORT_BY_OPTIONS,
    storeKey: 'selectedSortByValue',
  },
];

export type FilterValueType = {
  dataZone: 'All' | DataZoneLowerCaseString;
  dataQuality: 'All' | QualityLevel;
  dateRange: QualityDetailDateRange;
  sortBy: SelectedSortByValue;
};
